// GA4 / GTM dataLayer helpers.
// Events and parameters match google_api_integration_stack.docx §1.3–1.4.
// HIPAA: never push phone numbers, names, emails, or health terms.

function push(event, params = {}) {
  if (typeof window === 'undefined') return;
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event,
    ...params,
    timestamp: new Date().toISOString()
  });
}

export function trackPersonaSelected(persona) {
  push('persona_selected', {
    persona_id: persona.id,
    persona_name: persona.name
  });
}

export function trackLanguageSelected(languageCode) {
  push('language_selected', { language_code: languageCode });
}

export function trackCallbackRequested({ personaId, languageCode }) {
  // phone_validated is true because the form only submits after client validation;
  // the raw phone number is intentionally NOT included.
  push('callback_requested', {
    persona_id: personaId,
    phone_validated: true,
    language_preference: languageCode,
    consent_captured: true
  });
}

export function trackSubscriptionStarted({ planId, value, currency = 'USD' }) {
  push('subscription_started', {
    plan_id: String(planId),
    value: Number(value),
    currency
  });
}

export function trackSubscriptionCancelled({ planId, tenureDays }) {
  push('subscription_cancelled', {
    plan_id: String(planId),
    tenure_days: Number(tenureDays || 0)
  });
}

// URL parameter capture — gclid + utm_source + campaign — survives navigation
// via sessionStorage so we can forward attribution to the server on submit.
// The values are NOT read into analytics events that might leak campaign
// structure to third parties; they flow only to /api/callback.
export function captureAttribution() {
  if (typeof window === 'undefined') return;
  const qs = new URLSearchParams(window.location.search);
  const fields = {};
  for (const k of ['gclid', 'gbraid', 'wbraid', 'utm_source', 'utm_medium',
                    'utm_campaign', 'utm_term', 'utm_content', 'campaign_id']) {
    const v = qs.get(k);
    if (v) fields[k] = v;
  }
  if (Object.keys(fields).length > 0) {
    sessionStorage.setItem('alfred_attr', JSON.stringify(fields));
  }
}
export function readAttribution() {
  if (typeof window === 'undefined') return {};
  try { return JSON.parse(sessionStorage.getItem('alfred_attr') || '{}'); }
  catch { return {}; }
}

// Called after consent checkbox is checked and form submits. Upgrades
// Consent Mode V2 from default-deny to granted. See §2.3.
export function grantConsent() {
  if (typeof window === 'undefined' || typeof window.gtag !== 'function') {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(['consent', 'update', {
      analytics_storage: 'granted',
      ad_storage: 'granted',
      ad_user_data: 'granted',
      ad_personalization: 'granted'
    }]);
    return;
  }
  window.gtag('consent', 'update', {
    analytics_storage: 'granted',
    ad_storage: 'granted',
    ad_user_data: 'granted',
    ad_personalization: 'granted'
  });
}
